import mutations, {defaultState} from "./mutations";
import getters from "./getters";
import actions from "./actions";

export const namespace = "auth";

export const authStore = (action) => {
    return namespace + "/" + action;
};

export const auth = {
    namespaced: true,
    state: defaultState,
    mutations,
    getters,
    actions
};

export default {
    /**
     * Install the auth store into the app store
     *
     * @param store {{registerModule: function(string,Object)}}
     */
    install: function(store){
        store.registerModule(namespace, auth);
    }
};
